// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"3496":"graphql-print","4254":"56c12eb5","5970":"lottie"}[chunkId] || chunkId) + "." + {"3496":"7ef39872c8b54dd4","4254":"cfaf0f642ce9413b","4871":"4e32190b6854320a","5970":"b7d77b1b9bc21f3d","7952":"51b542cd3e398f5e"}[chunkId] + ".js";
};